import React from 'react';
import { useHistory } from 'react-router-dom';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import PaymentsBalanceView from './BalanceView';

const PaymentsBalanceViewController = () => {
  const history = useHistory();
  const goBackButton = () => {
    GoogleAnalytics.writeLog('back-from-balance', 'backbutton');
    history.push('/pagos');
  };

  return <PaymentsBalanceView goBackButton={goBackButton} />;
};

export default PaymentsBalanceViewController;
